import type { TestStatus } from '../../utils/calibrationStatus';

export const getStatusBadgeProps = (status: TestStatus, isDarkMode = false) => {
  switch (status) {
    case 'not-started':
      return {
        label: 'Not Started',
        sx: {
          backgroundColor: isDarkMode ? 'rgba(107, 114, 128, 0.3)' : '#6B7280',
          color: isDarkMode ? 'rgba(156, 163, 175, 1)' : '#FFFFFF',
          fontWeight: 600,
          borderRadius: '4px',
          fontSize: '0.75rem'
        }
      };
    case 'in-progress':
      return {
        label: 'In Progress',
        sx: {
          backgroundColor: isDarkMode ? 'rgba(245, 158, 11, 0.3)' : '#F59E0B',
          color: isDarkMode ? 'rgba(251, 191, 36, 1)' : '#FFFFFF',
          fontWeight: 600,
          borderRadius: '4px',
          fontSize: '0.75rem'
        }
      };
    case 'pass':
      return {
        label: 'Pass',
        sx: {
          backgroundColor: isDarkMode ? 'rgba(16, 185, 129, 0.3)' : '#10B981',
          color: isDarkMode ? 'rgba(52, 211, 153, 1)' : '#FFFFFF',
          fontWeight: 600,
          borderRadius: '4px',
          fontSize: '0.75rem'
        }
      };
    case 'fail':
      return {
        label: 'Fail',
        sx: {
          backgroundColor: isDarkMode ? 'rgba(239, 68, 68, 0.3)' : '#EF4444',
          color: isDarkMode ? 'rgba(248, 113, 113, 1)' : '#FFFFFF',
          fontWeight: 600,
          borderRadius: '4px',
          fontSize: '0.75rem'
        }
      };
    default:
      return {
        label: 'Unknown',
        sx: {
          backgroundColor: isDarkMode ? 'rgba(107, 114, 128, 0.3)' : '#6B7280',
          color: isDarkMode ? 'rgba(156, 163, 175, 1)' : '#FFFFFF',
          fontWeight: 600,
          borderRadius: '4px',
          fontSize: '0.75rem'
        }
      };
  }
};
